export enum ComplexContentTypeEnum {
  "BODY_JSON" = "BODY_JSON",

  "BODY_XML" = "BODY_XML",

  "BODY_STRING" = "BODY_STRING",

  "HEADER_STRING" = "HEADER_STRING",

  "URL_STRING" = "URL_STRING",
}
